export default {
  getThemes(state) {
    return state.themes;
  },

  getThemeById: (state) => (themeId) => {
    return state.themes.find((theme) => theme.id === themeId);
  },

  getPreviewTheme: (state) => {
    return state.previewTheme;
  },

  getPreviewThemeCss: (state) => {
    if (state.previewTheme.web_form_theme_font_id === null) {
      return {};
    }

    const fontFamily = window.__RMP_EVENTS_FONTS_AVAILABLE_FOR_THEMES__.find((font) => {
      return font.id === +state.previewTheme.web_form_theme_font_id;
    });

    return {
      '--fontFamily': `'${fontFamily.name}'`,
      '--formButtonTextColor': state.previewTheme.form_button_text_colour,
      '--formButtonBackground': state.previewTheme.form_button_background,
      '--formButtonBorderColour': state.previewTheme.form_button_border_colour,
      '--formTextAnswerColor': state.previewTheme.form_answers_text_colour,
      '--formTextQuestionColor': state.previewTheme.form_questions_text_colour,
      '--formBackgroundImage': (state.previewTheme.form_background_image_as_base64_string) ? `url("${state.previewTheme.form_background_image_as_base64_string}")` : '',
      '--formBackgroundColor': state.previewTheme.form_background,
    };
  },

  getSelectedTheme: (state) => {
    return state.themes.find((theme) => theme.isSelected === true);
  },

  getEditableThemeById: (state) => (themeId) => {
    const item = state.themes.find((theme) => theme.id === themeId);
    return { ...item };
  },

};
